import { BrandEnum } from "../_common/enum/brand.enum";
import { HELLO_HIGHLIGHT_COLOR, HELLO_PRIMARY_COLOR, HELLO_PRIMARY_LIGHT_COLOR, HELLO_PULSE_COLOR, HELLO_SECONDARY_COLOR } from "../_const/brandColors/hello.color.const";
import { LOW_HIGHLIGHT_COLOR, LOW_PRIMARY_COLOR, LOW_PRIMARY_LIGHT_COLOR, LOW_PULSE_COLOR, LOW_SECONDARY_COLOR } from "../_const/brandColors/low.color.const";
import { LOWQUOTE_HIGHLIGHT_COLOR, LOWQUOTE_PRIMARY_COLOR, LOWQUOTE_PRIMARY_LIGHT_COLOR, LOWQUOTE_PULSE_COLOR, LOWQUOTE_SECONDARY_COLOR } from "../_const/brandColors/lowquote.color.const";
import LowQuotesLogoSymbol from '../_assets/images/brands/LowQuotes.png';
import LowLogoSymbol from '../_assets/images/brands/Low.png';
import HelloLogoSymbol from '../_assets/images/brands/Hello.png';
import TrueWealthLogoSymbol from '../_assets/images/brands/TrueWealth.png';
import { TRUE_WEALTH_HIGHLIGHT_COLOR, TRUE_WEALTH_PRIMARY_COLOR, TRUE_WEALTH_PRIMARY_LIGHT_COLOR, TRUE_WEALTH_PULSE_COLOR, TRUE_WEALTH_SECONDARY_COLOR } from "../_const/brandColors/trueWealth.color.const";



export function getBrandPrimaryColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return LOWQUOTE_PRIMARY_COLOR;

        case BrandEnum.Hello:
            return HELLO_PRIMARY_COLOR;

        case BrandEnum.Low:
            return LOW_PRIMARY_COLOR;

        case BrandEnum.TrueWealth:
            return TRUE_WEALTH_PRIMARY_COLOR;

        default:
            return LOWQUOTE_PRIMARY_COLOR;
    }
}

export function getBrandSecondaryColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return LOWQUOTE_SECONDARY_COLOR;

        case BrandEnum.Hello:
            return HELLO_SECONDARY_COLOR;

        case BrandEnum.Low:
            return LOW_SECONDARY_COLOR;

        case BrandEnum.TrueWealth:
            return TRUE_WEALTH_SECONDARY_COLOR;

        default:
            return LOWQUOTE_SECONDARY_COLOR;
    }
}

export function getBrandVibrantColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return LOWQUOTE_PULSE_COLOR;

        case BrandEnum.Hello:
            return HELLO_PULSE_COLOR;

        case BrandEnum.Low:
            return LOW_PULSE_COLOR;

        case BrandEnum.TrueWealth:
            return TRUE_WEALTH_PULSE_COLOR;

        default:
            return LOWQUOTE_PULSE_COLOR;
    }
}

export function getBrandPrimaryLightColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return LOWQUOTE_PRIMARY_LIGHT_COLOR;

        case BrandEnum.Hello:
            return HELLO_PRIMARY_LIGHT_COLOR;

        case BrandEnum.Low:
            return LOW_PRIMARY_LIGHT_COLOR;

        case BrandEnum.TrueWealth:
            return TRUE_WEALTH_PRIMARY_LIGHT_COLOR;

        default:
            return LOWQUOTE_PULSE_COLOR;
    }
}

export function getBrandHighlightColor(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return LOWQUOTE_HIGHLIGHT_COLOR;

        case BrandEnum.Hello:
            return HELLO_HIGHLIGHT_COLOR;

        case BrandEnum.Low:
            return LOW_HIGHLIGHT_COLOR;

        case BrandEnum.TrueWealth:
            return TRUE_WEALTH_HIGHLIGHT_COLOR;

        default:
            return LOWQUOTE_HIGHLIGHT_COLOR;
    }
}

export function getBrandFontFamily(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return '"Futura", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        case BrandEnum.Low:
            return '"Objektiv", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        case BrandEnum.Hello:
            return '"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        case BrandEnum.TrueWealth:
            return '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        default:
            return '"Futura", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    }
}

export function getBrandCallbackLink(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return "https://lowquotes.ie/request-a-call-back/";
        case BrandEnum.Low:
            return "https://low.ie/get-a-consultation/";
        //case BrandEnum.Hello:
        //    return "https://hello.ie/request-a-call-back/"; //uncomment when live
        case BrandEnum.Hello:
            return "https://hello.lowquotes.ie/request-a-call-back/";
        case BrandEnum.TrueWealth:
            return "https://truewealth.ie/request-a-call-back/";
        default:
            return ""
    }
}

export function getBrandPrivacyPolicyLink(brand: BrandEnum) {
    switch (brand) {
   
        case BrandEnum.LowQuote:
            return "https://lowquotes.ie/LQ-Terms-of-business.pdf";
        case BrandEnum.Low:
            return "https://low.ie/Low-Terms-of-business.pdf";
        case BrandEnum.Hello:
            return "https://hello.ie/LQ-Terms-of-business.pdf";
        case BrandEnum.TrueWealth:
            return "https://truewealth.ie/TW-Terms-of-business.pdf";
        default:
            return ""
    }
}

export function getBrandHQCompletedLink(brand: BrandEnum) {
    switch (brand) {

        case BrandEnum.LowQuote:
            return "https://lowquotes.ie/thank-you-application";
        case BrandEnum.Low:
            return "https://low.ie/thank-you-application";
        case BrandEnum.Hello:
            return "https://hello.lowquotes.ie/thank-you-application";
        //case BrandEnum.Hello: //uncomment in live
        //    return "https://hello.ie/thank-you-application";
        case BrandEnum.TrueWealth:
            return "https://truewealth.ie/thank-you-application";
        default:
            return ""
    }
}

export function getBrandLogoSymbol(brand: BrandEnum) {
    switch (brand) {
        case BrandEnum.LowQuote:
            return LowQuotesLogoSymbol;

        case BrandEnum.Low:
            return LowLogoSymbol;

        case BrandEnum.Hello:
            return HelloLogoSymbol;

        case BrandEnum.TrueWealth:
            return TrueWealthLogoSymbol;

        default:
            return "";
    }
}

export const brandToFlagMap = {
    [BrandEnum.LowQuote]: "isUsingLowQuoteLogo",
    [BrandEnum.Low]: "isUsingLowLogo",
    [BrandEnum.Hello]: "isUsingHelloLogo",
    [BrandEnum.TrueWealth]: "isUsingTrueWealthLogo",
} as const;

